import BaseService from '../base';

class Shift extends BaseService {}

export default new Shift('shifts', 'Shift');
